import { render, staticRenderFns } from "./bonus_points.vue?vue&type=template&id=36e82688&scoped=true"
import script from "./bonus_points.vue?vue&type=script&lang=js"
export * from "./bonus_points.vue?vue&type=script&lang=js"
import style0 from "./bonus_points.vue?vue&type=style&index=0&id=36e82688&prod&lang=scss&scoped=true"
import style1 from "./bonus_points.vue?vue&type=style&index=1&id=36e82688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e82688",
  null
  
)

export default component.exports